import { TemplatePage } from './types';

const petsPage: TemplatePage = {
  header: {
    color: '#F4C0CD',
    icon: 'images/video-templates/pets.jpg',
    title: 'Pets Video Templates Collection',
    title_meta: '50+ Free and Customizable Pets Video Templates',
    description_meta:
      'Promote your pet-care business or just share cute fluffy videos with your followers. Wave.video prepared a special ' +
      'collection of 50+ pets video templates about woofs and meows.',
    description:
      'These video templates are to make adorable and funny videos about our furry companions. Make funny video memes ' +
      'featuring your dog, promote your pet-care business, or help rescue those who don’t have a beloved human yet.'
  },
  footer: {
    category: 'Pets',
    description:
      'Wave.video editor comes with a wide range of video templates that you can easily customize to your industry, use ' +
      'case and brand. It doesn’t take a lot of time and effort to come up with attention-grabbing video content. Browse ' +
      'the collection of professionally made video templates, find the ones you like, and adapt them to your needs using ' +
      'powerful editing features.'
  },
  content: [
    {
      type: 'templates',
      title: 'pets',
      search: { category: '/Industries/Pets' }
    },
    {
      type: 'stocks',
      title: 'Pets',
      search: { name: 'pets' }
    },
    { type: 'calendar' }
  ]
} ;

export default petsPage;
